class InitializeActions {

	// -----------------
	// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
	// They do not themselves have any side-effects; they just describe something that is going to happen.

	public loadCurrencies(currencies: CurrencySummary[]): ILoadCurrenciesAction {
		return {
			currencies,
			type: "LOAD_CURRENCIES",
		};
	}

	public loadConfigOptions(configOptions: ConfigOptionItem[]): ILoadConfigOptionsAction {
		return {
			configOptions,
			type: "LOAD_CONFIGOPTIONS",
		};
	}
}

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = new InitializeActions();



// WEBPACK FOOTER //
// ./src/store/initialize/initialize-actions.ts